import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={9 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 9 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M8.05878 19.164C8.01362 18.8699 7.93806 18.2583 7.6696 17.6965C7.40747 17.1484 7.15421 16.5952 7.06303 16.0059C6.56917 12.8237 6.67215 9.34744 5.63081 5.53883C4.93813 3.00496 4.89381 1.47105 4.40627 1.3823C3.86513 1.2839 3.13235 2.8271 3.07832 5.63946C3.00319 9.57543 2.19866 13.4694 2.00828 15.9105C1.9188 17.0608 1.58279 17.6791 1.48613 17.9832C1.4034 18.2438 1.34768 18.5424 1.31349 18.8821C1.19825 20.0206 1.22401 22.3346 1.32236 23.9261C1.37976 24.8577 1.51694 25.2391 2.26534 25.3C3.8778 25.4311 6.18505 25.3917 7.63119 25.2194C8.15249 25.1574 8.19808 24.821 8.21243 24.2057C8.24662 22.7067 8.28039 20.6043 8.05878 19.164Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
